export const defaultPadding = 'px-3 pb-3';
